import React, { useEffect, useState } from "react";
import { getAllEscrows } from "../../services/adminEscrowService";
import { EscrowTransaction } from "../../types/exchange";
import { Box, Typography, Paper, Grid, Alert } from "@mui/material";

const AdminEscrowList: React.FC = () => {
  const [escrows, setEscrows] = useState<EscrowTransaction[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getAllEscrows()
      .then(setEscrows)
      .catch(() => setError("Failed to load escrows"));
  }, []);

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        All Escrow Transactions (Admin)
      </Typography>
      {escrows.length === 0 ? (
        <Alert severity="info">No escrows found.</Alert>
      ) : (
        <Grid container spacing={2}>
          {escrows.map((escrow) => (
            <Grid item xs={12} md={6} key={escrow.id}>
              <Paper sx={{ p: 2 }}>
                <Typography>
                  <b>ID:</b> {escrow.id}
                </Typography>
                <Typography>
                  <b>Status:</b> {escrow.status}
                </Typography>
                <Typography>
                  <b>Amount:</b> {escrow.amount_usd} USD / {escrow.amount_bs} Bs
                </Typography>
                <Typography>
                  <b>Buyer:</b> {escrow.buyer_id}
                </Typography>
                <Typography>
                  <b>Seller:</b> {escrow.seller_id}
                </Typography>
                <Typography>
                  <b>Created:</b> {escrow.created_at}
                </Typography>
                {/* Add more fields as needed */}
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default AdminEscrowList;
